import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '@/store/reducers';

const store = configureStore({
  reducer: rootReducer,
  // Enable Redux DevTools extension
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // Ignore these field paths in all actions
        ignoredActionPaths: [],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }),
});

export default store;
